var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminCoursesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8033_3870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 14H4C3.73488 13.9997 3.4807 13.8942 3.29323 13.7068C3.10576 13.5193 3.0003 13.2651 3 13V1C3.00026 0.734865 3.10571 0.480665 3.29319 0.293186C3.48066 0.105707 3.73486 0.000264738 4 0H12C12.2651 0.000304367 12.5193 0.105759 12.7068 0.293229C12.8942 0.4807 12.9997 0.734877 13 1V9.3091L10.5 8.0591L8 9.3091V1H4V13H12V11H13V13C12.9996 13.2651 12.8942 13.5193 12.7067 13.7067C12.5193 13.8942 12.2651 13.9996 12 14ZM10.5 6.9409L12 7.6909V1H9V7.6909L10.5 6.9409Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8033_3870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminCoursesIcon);
export default __webpack_public_path__ + "static/media/admin_courses_icon.05b40c704a4c4a018dc9b1ae6bd77c85.svg";
export { ForwardRef as ReactComponent };